import styled from "styled-components";
import { Select } from "antd";

export const ContainerSelectGroupItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const CustomSelect = styled(Select)`
  flex: 1;
`;
